module.exports = __webpack_public_path__ + "media/images/gift-icon-d083e27dd9db0b793177c072813ab344.png";